export const beep = new Audio('https://d1l6fcuu6fcorr.cloudfront.net/beep.mp3');
